// import { provideHttpClient, withInterceptors } from '@angular/common/http';
// import { bootstrapApplication } from '@angular/platform-browser';
// import { provideRouter } from '@angular/router';
// import { AppComponent } from './app.component';
// import { customInterceptor } from './services/custom.interceptor';

// bootstrapApplication(AppComponent, {
//   providers: [
//     // routes
//     // provideRouter(routes),
//     // http client
//     provideHttpClient(
//       // registering interceptors
//       withInterceptors([customInterceptor])
//     ),
//   ],
// }).catch((err) => console.error(err));

import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { provideTablerIcons } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { customInterceptor } from '../../../shared/src/lib/services/custom.interceptor';
import { ApiService } from '../../../shared/src/lib/services/api.service';
import { routes } from './app.routes';
import {provideFeatureFlag} from "../../../shared/src/lib/providers/feature-flag.provider";

export const appConfig: ApplicationConfig = {
  providers: [
    provideFeatureFlag(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([customInterceptor])),
    importProvidersFrom(ApiService),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideTablerIcons(TablerIcons),
    importProvidersFrom(FeatherModule.pick(allIcons)),
  ],
};

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export { AppSettings, defaults } from '../../../shared/src/lib/services/core.service';
